/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'

/**
 * Container styles for the dynamic form
 */
export const Container = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px 0;
`

/**
 * Section container styles for each form group
 */
export const SectionContainer = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

/**
 * Section header styles containing title and subtitle
 */
export const SectionHeader = css`
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
  border-bottom: 1px solid ${colors.NEUTRAL_200};
`

/**
 * Section title styles
 */
export const SectionTitle = css`
  font-size: 20px;
  font-weight: 600;
  color: ${colors.NEUTRAL_0};
  line-height: 1.2;
`

/**
 * Section subtitle styles
 */
export const SectionSubtitle = css`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.NEUTRAL_100};
  line-height: 1.4;
`

/**
 * Questions grid styles - 2 columns on desktop, 1 on mobile
 */
export const QuestionsGrid = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: start;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  .mobile-preview & {
    grid-template-columns: 1fr;
  }
`

/**
 * Individual question container styles
 */
export const QuestionContainer = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`

/**
 * Empty state container styles
 */
export const EmptyStateContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
  gap: 16px;
  text-align: center;
  border: 2px dashed ${colors.NEUTRAL_300};
  border-radius: 8px;
  background-color: ${colors.NEUTRAL_900};
`

/**
 * Empty state title styles
 */
export const EmptyStateTitle = css`
  font-size: 18px;
  font-weight: 600;
  color: ${colors.NEUTRAL_50};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

/**
 * Empty state message styles
 */
export const EmptyStateMessage = css`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.NEUTRAL_100};
  line-height: 1.5;
`

/**
 * Button container styles for bottom action buttons
 */
export const ButtonContainer = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 8px;
  align-self: flex-end;
  width: 50%;
  margin-top: 24px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    width: 100%;
  }

  .mobile-preview & {
    flex-direction: column-reverse;
    width: 100%;

    & > * {
      width: 100%;
    }
  }
`
